import { render, staticRenderFns } from "./points-filter.vue?vue&type=template&id=4d1bdd00&scoped=true"
import script from "./points-filter.vue?vue&type=script&lang=js"
export * from "./points-filter.vue?vue&type=script&lang=js"
import style0 from "./points-filter.vue?vue&type=style&index=0&id=4d1bdd00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1bdd00",
  null
  
)

export default component.exports